module.exports = __webpack_public_path__ + "img/icon_curriculum.ebad4824.png";